import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { PriceListItem, PriceListItemCreate, PriceListItemFilter } from '../data/priceListItem';

export function createPriceListItemService(client: AxiosInstance) {
  return createCrudService<PriceListItem, PriceListItemCreate, PriceListItemFilter>(
    client,
    '/master-data/PriceListItem',
    'id',
  );
}

export type PriceListItemService = CrudService<PriceListItem, PriceListItemCreate, PriceListItemFilter>;
